import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María Fernández',
    city: 'Córdoba',
    text: 'Trabajo sola en RRHH de una empresa de 25 personas. Este kit me salvó de varios errores que hubieran terminado en problemas legales. Lo mejor es que todo está en PDF y lo consulto cuando lo necesito.',
    rating: 5
  }, {
    name: 'Laura Gómez',
    city: 'Rosario',
    text: 'Finalmente tengo todo organizado y documentado. Las plantillas son súper prácticas y me ahorran horas cada mes. Ojalá lo hubiera tenido antes.',
    rating: 5
  }, {
    name: 'Silvina Rodríguez',
    city: 'Mendoza',
    text: 'Soy contadora pero me tocó hacer RRHH también. Este material es clarísimo y me dio la seguridad que necesitaba para manejar liquidaciones, licencias y despidos sin miedo.',
    rating: 5
  }, {
    name: 'Carolina Pérez',
    city: 'La Plata',
    text: 'Lo compré por las plantillas pero los casos prácticos son oro puro. Me pasaron varias de esas situaciones y ahora sé exactamente cómo actuar.',
    rating: 5
  }, {
    name: 'Andrea Martínez',
    city: 'Mar del Plata',
    text: 'Trabajo en una PYME familiar y siempre tuve miedo de hacer algo mal. Con este kit tengo todo paso a paso y documentado. Vale cada peso.',
    rating: 5
  }];
  return <section className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-133" data-mp="zw674jhgjfdh">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-134" data-mp="zysfglc69ywr">
        Lo que dicen quienes ya lo tienen
      </h2>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-135" data-mp="q7ef6bcecv2k">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-300" data-id="element-136" data-mp="v4o5dt7m1arg" data-mpi={index}>
            <div className="flex gap-1 mb-3" data-id="element-137" data-mp="1nmk2ojz93wct">
              {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-138" data-mp="1xi8ymxpvot7q" data-mpi={i} />)}
            </div>
            <p className="text-gray-700 mb-4 italic" data-id="element-139" data-mp="1oh2gylbhtccw">"{testimonial.text}"</p>
            <div className="flex items-center gap-2" data-id="element-140" data-mp="1oj5hw0e6opwe">
              <div className="w-10 h-10 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center font-bold text-gray-700" data-id="element-141" data-mp="1jh6fasq9px0i">
                {testimonial.name.charAt(0)}
              </div>
              <div data-id="element-142" data-mp="19r3motn26l2p">
                <p className="font-semibold text-gray-900" data-id="element-143" data-mp="19qli99q8t0jp">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-500" data-id="element-144" data-mp="10s02tng2i1n5">{testimonial.city}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}